import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Layout from "@/Layout";
import HomePage from "@/pages/HomePage";
import StartPage from "@/pages/StartPage";
import PlusPage from "@/pages/PlusPage";
import RooftopPage from "@/pages/RooftopPage";
import FormazionePage from "@/pages/FormazionePage";
import LinktreePage from "@/pages/LinktreePage";
import BrandKitPage from "@/pages/BrandKitPage";
import EntiPage from "@/pages/EntiPage";
import MerchPage from "@/pages/MerchPage";
import AdsLandingPage from "@/pages/AdsLandingPage";
import AgencyPage from "@/pages/AgencyPage";
import ScopriPage from "@/pages/ScopriPage";
import MappaInternaPage from "@/pages/MappaInternaPage";
import DarkModePage from "@/pages/DarkModePage";
import DarkIntroPage from "@/pages/DarkIntroPage";
import VoiceInboxPage from "@/pages/VoiceInboxPage";
import BrandBookPage from "@/pages/BrandBookPage";
import VirtualTourPage from "@/pages/VirtualTourPage";
import AcademyPage from "@/pages/AcademyPage";
import AdminPage from "@/pages/AdminPage";
import LogoDownloadPage from "@/pages/LogoDownloadPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/dark-intro" element={<DarkIntroPage />} />
        <Route path="/links" element={<LinktreePage />} />
        <Route path="/brand-kit" element={<BrandKitPage />} />
        <Route path="/merchandising" element={<MerchPage />} />
        <Route path="/per-agenzie" element={<AgencyPage />} />
        <Route path="/scopri" element={<ScopriPage />} />
        <Route path="/mappa-interna" element={<MappaInternaPage />} />
        <Route path="/darkmode" element={<DarkModePage />} />
        <Route path="/ads/:pkg" element={<AdsLandingPage />} />
        <Route path="/enti" element={<EntiPage />} />
        <Route path="/inbox" element={<VoiceInboxPage />} />
        <Route path="/brand-book" element={<BrandBookPage />} />
        <Route path="/logo-download" element={<LogoDownloadPage />} />
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/start" element={<StartPage />} />
          <Route path="/plus" element={<PlusPage />} />
          <Route path="/rooftop" element={<RooftopPage />} />
          <Route path="/sbp360" element={<Navigate to="/deducibile100" replace />} />
          <Route path="/formazione" element={<FormazionePage />} />
          <Route path="/deducibile100" element={<VirtualTourPage />} />
          <Route path="/academy" element={<AcademyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/deducibile" element={<FormazionePage />} />
          <Route path="/consulenza" element={<FormazionePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
